module.exports = __webpack_public_path__ + "assets/img/history.1589bbc1.svg";